export default __webpack_public_path__ + "static/media/empty-chart.498b68fd.svg";